import { takeLatest, put, delay } from 'redux-saga/effects';

import * as actionTypes from './actionTypes';
import { dequeueNotification, enqueueNotification } from './actions';

function* createNotification({ payload }) {
  yield put(enqueueNotification(payload));
  yield delay(100);
  yield put(dequeueNotification());
}

export default function* notificationsSagas() {
  yield takeLatest(actionTypes.ADD_TOAST_NOTIFICATION, createNotification);
}
